import { lazy } from 'react'
import type { Area } from '@briary/shared'
import { SUPERADMIN_ONLY } from '../../lib/auth'
import type { NavItem, RouteDef } from '../types'
export const ARCHIVE_ROUTES: RouteDef[] = [{ path: '/admin/archive', component: lazy(() => import('./LegacyArchive')), perm: SUPERADMIN_ONLY }]
export function withArchiveLink(groups: { label: string; items: NavItem[] }[], area: Area, superadmin: boolean) {
  if (area !== 'admin' || !superadmin) return groups
  const link: NavItem = { label: 'Old Hub archive', path: '/admin/archive', icon: 'history', perm: SUPERADMIN_ONLY }
  return groups.some(group => group.label === 'Admin')
    ? groups.map(group => group.label === 'Admin' ? { ...group, items: [...group.items, link] } : group)
    : [...groups, { label: 'Admin', items: [link] }]
}
